<template>
<div class="virtual-map-frame page-container-content tabgroup">
  <div class="full-wrapper">
    <div class="left-area">
      <w-virtual-map-tree ref="virtualMapTree" @select-target="selectTarget" @fullscreen-on="showFullscreenPopup" />
    </div>
    <div class="right-area">
      <w-virtual-map-timeline v-if="showTimelineFlag" :active="active && showTimelineFlag" @select-target-map="selectTargetMap"/>
      <w-virtual-map-info v-else :selected-params = "selectedParams" @change-show-timeline-flag="changeShowTimelineFlag"/>
    </div>
    <div class="bottom-area full-f-chart">
      <w-virtual-map-event-info class="no-spacing-bottom" :selected-node="selectedNode" :active="active"></w-virtual-map-event-info>
    </div>
  </div>
  <w-virtual-map-frame-fullscreen-popup ref="fullscreenPopup"></w-virtual-map-frame-fullscreen-popup>
</div>
</template>

<script>
import API from '@/api/virtual/performance/virtualmap';
import WVirtualMapEventInfo from '@/views/performance/components/virtual/VirtualMapEventInfo';
import WVirtualMapTree from '@/views/performance/components/virtual/VirtualMapTree';
import WVirtualMapTimeline from '@/views/performance/components/virtual/VirtualMapTimeline';
import WVirtualMapInfo from '@/views/performance/components/virtual/VirtualMapInfo';
import WVirtualMapFrameFullscreenPopup from '@/views/performance/components/virtual/VirtualMapFrameFullscreenPopup';
import { mapGetters } from 'vuex';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WVirtualMapFrame',
  components: {
    WVirtualMapEventInfo,
    WVirtualMapTree,
    WVirtualMapTimeline,
    WVirtualMapInfo,
    WVirtualMapFrameFullscreenPopup,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      showTimelineFlag: true,
      selectedParams: {},
      configActive: false,
    };
  },
  computed: mapGetters(['selectedNode', 'selectedObjDefineIds']),
  watch: {
    selectedNode: {
      handler() {
        if (this.active) {
          this.showTimelineFlag = true;
          if (this.$refs.taskTable === undefined) {
            this.$nextTick(() => {
              this.loadStore();
            });
          } else {
            this.loadStore();
          }
        }
      },
      immediate: true,
    },
    active: {
      handler(newValue) {
        if (newValue) {
          this.loadStore();
        }
      },
    },
  },
  methods: {
    loadStore() {
      const { selectedNode } = this;
      let id = selectedNode.obj && selectedNode.obj.objId;
      let idType = 'objId';
      const hypervisorType = selectedNode.hypervisorType;
      if (isEmpty(id)) {
        id = selectedNode.virtualcenterGroupId;
        idType = 'virtualcenterGroupId';
      }
      API.vmsTreeLayout(id, idType, hypervisorType).then((response) => {
        if (response.data.success) {
          const responseData = response.data.data;
          if (this.$refs.virtualMapTree) {
            this.$refs.virtualMapTree.drawVirtualMapTree(responseData);
          }
        }
      });
    },
    /**
     * Map 에서 대상이 선택됐을 경우 선택된 대상 설정
     * @author kimjy
     * @param  {Object} obj {objId, objName, objtypeId}
     */
    selectTarget(obj) {
      this.showTimelineFlag = false;
      this.selectedParams = obj;
    },
    /**
     * 타임라인에서 대상이 선택됐을 경우 선택된 대상을 Map에 설정
     * @author kimjy
     * @param  {Integer} objId
     */
    selectTargetMap(objId) {
      this.$refs.virtualMapTree.clickedNodeFromTimeLine(objId);
    },
    changeShowTimelineFlag(flag) {
      this.$nextTick(() => {
        this.$refs.virtualMapTree.changeShowTime(flag);
        this.showTimelineFlag = flag;
      });
    },
    showFullscreenPopup() {
      this.$refs.fullscreenPopup.open();
    },
  },
};
</script>
<style lang="scss" scoped>
  .virtual-map-frame.page-container-content.tabgroup .full-wrapper {
    height: calc(100vh - 195px);
    .left-area {
      width: calc(100% - 500px);
      margin-left:0px;
      float:left;
      .no-spacing-bottom {
        display: inline-block;
      }
    }
    .right-area {
       width: 500px;
       float: left;
       padding-right: 1px;
       height: 100%;
    }
    // 아래쪽 이벤트 영역에서 CSS를 가져온 것 중 적용시키지 말아야 할 것들을 덮어쓴다.
    .bottom-area.full-f-chart {
      min-height: 0px;
      background-color: transparent;
      padding: 0px;
      margin: 0px;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapFrame.vue